import { gql } from '@apollo/client';

export const AI_WRITE_PREVIEW = gql`
  mutation aiWritePreview($aiWritePreviewInput: AiWritePreviewInput!) {
    aiWritePreview(aiWritePreviewInput: $aiWritePreviewInput) {
      success
      title
      intro
      tableOfContents {
        title
        subheadings {
          title
          subheadings {
            title
          }
        }
      }
      metaDesc
      tags
      gptResponse1
      message
    }
  }
`;

export const AI_WRITE_POST = gql`
  mutation aiWritePost($aiWritePostInput: AiWritePostInput!) {
    aiWritePost(aiWritePostInput: $aiWritePostInput) {
      success
      message
    }
  }
`;
